import './header.scss';
import * as images from './../../assets/images';

const Header: React.FC = () => {
    return (
        <div className='header-container'>
            <div className='header-content'>
                <img src={images.LogoH} alt={'logo'} />
            </div>
            <div className='header-support-container'>
                <span>
                    Need help? Call <a href="tel:+1-937-884-1087" style={{ color: 'inherit' }}>+1 (937) 884-1087</a>
                </span>
            </div>
        </div>
    );
}

export default Header;